import React, { forwardRef } from 'react'
import { Box, BoxProps } from '@chakra-ui/react'

const CardTagged = forwardRef(
  (props: BoxProps, ref: React.Ref<HTMLDivElement>) => {
    return (
      <Box
        w="100%"
        minHeight="100px"
        bg="white"
        mb="30px"
        borderLeft={'6px solid'}
        borderRadius={'6px'}
        boxShadow="0 0 10px rgba(0, 0, 0, .1)"
        display="flex"
        alignItems="center"
        {...props}
        ref={ref}
      />
    )
  },
)

CardTagged.propTypes = {}

export default CardTagged
